// extracted by mini-css-extract-plugin
export var container = "_6x-0";
export var infoButton = "_6x-1";
export var label = "_6x-3";
export var labelExpanded = "_6x-4";
export var price = "_6x-5";
export var priceExpanded = "_6x-6";
export var title = "_6x-2";